import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../../assets/css/layouts/footer.css";
import WLogo from "../../assets/img/WLogo_s.svg";

export default function Footer() {
  const location = useLocation();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <div className="footer-title-row">
            <img
              src={WLogo}
              className="footer-logo"
              alt="덕성여자대학교 총학생회 로고"
            />
            <h2>덕성여자대학교 총학생회</h2>
          </div>

          <p className="footer-address">
            서울특별시 도봉구 삼양로144길 33, 덕성여자대학교 학생회관 2층 총학생회실(01369)
          </p>

          <div className="footer-mails">
            <p>대표 메일 | stdcouncil@duksung.ac.kr</p>
            <p>협력 메일 | partnership@duksung.ac.kr</p>
          </div>
        </div>

        <div className="footer-right">
          <div className="footer-link">
            <Link to="/policy/terms" state={{ backgroundLocation: location }}>
              이용약관
            </Link>
            <span>|</span>
            <Link to="/policy/privacy" state={{ backgroundLocation: location }}>
              개인정보처리방침
            </Link>
          </div>

          <p className="footer-copy">
            Copyright © Duksung Women's University Student Council. All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}